<template>
  <v-page page="Reports" :breadcrumb="breadcrumb">
    <Spinner ref="spinner"></Spinner>
    <v-container ma-0 px-3 pt-0 pb-0>
      <v-layout text-xs-center>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-center row align-center>
            <v-flex pa-0>
              <div pa-0>
                <!-- HEADER -->
                <v-layout justify-start row align-center mt-3 mb-1>
                  <v-flex align-center>
                    <div
                      v-if="reportInfo.ReportId !== null"
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >{{reportInfo.ReportTitle}}</div>
                    <div
                      v-if="reportInfo.ReportId !== null"
                      class="text-xs-left align-center"
                      style="font-size: 15px;"
                    >
                      <strong>Submitted:</strong>
                      {{reportInfo.SubmissionDate | formatDateTime}} by {{reportInfo.SubmittedBy !=null ? reportInfo.SubmittedBy : "SYSTEM"}}
                    </div>
                    <div
                      v-if="reportInfo.ReportId !== null"
                      class="text-xs-left align-center"
                      style="font-size: 15px;"
                    >
                      <strong>Output:</strong>
                      {{reportInfo.Output}}
                    </div>
                  </v-flex>
                  <v-flex align-center xs7>
                    <v-layout row>
                      <!-- <v-flex xs3>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlCategory"
                          v-model="filters.CategoryId"
                          item-text="Text"
                          item-value="Value"
                          label="Category"
                          clearable
                          @change="filterReports"
                        >
                        
                        </v-autocomplete>
                      </v-flex>
                       <v-flex xs3>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlSubmitBy"
                          v-model="filters.Type"
                          item-text="Text"
                          item-value="Text"
                          label="Submitted By"
                          clearable
                         @change="filterReports"
                        ></v-autocomplete>
                      </v-flex>-->

                      <v-flex xs4 ml-5>
                        <v-layout row>
                          <v-text-field
                            v-model="search"
                            label="Search"
                            single-line
                            hide-details
                            class="align-center mt-0 pt-0"
                            @keyup.enter="filterReports"
                          ></v-text-field>
                          <v-btn @click="filterReports" icon mx-2 class="TierButton my-0 py-0">
                            <v-icon style="font-size:18px">fa-search</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex>
                    <v-layout class="buttons" justify-end row align-center>
                      <a
                        style="text-decoration: none"
                        class="align-center mr-4"
                        @click="exportToExcel"
                      >EXCEL</a>
                      <a
                        style="text-decoration: none"
                        class="align-center"
                        @click="exportToCSV"
                      >TO CSV</a>
                      <!-- <v-btn class="TierButton mb-1 mr-3 ml-1" @click="">
                        DOWNLOAD
                      </v-btn>
                      <v-btn class="TierButton mb-1 mr-0 ml-1" @click="">
                        
                      </v-btn>-->
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- END HEADER -->

                <!-- SERVICES TABLE -->
                <v-data-table
                  :headers="headers"
                  :items="reportView"
                  :item-key="reportView.index"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :loading="loading"
                  :total-items="totalRecords"
                  @update:pagination="paginationUpdated"
                  hide-details
                  class="fixed-header v-table__overflow striped-table no-pagination-btn"
                  style="max-height: calc(84vh - 10px);backface-visibility: hidden;"
                >
                  <!-- <template v-slot:headers="props">
      <tr>
        <th
          v-for="header in props.headers"
          :key="header.text"
          :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', 'text-xs-right'? header.align == 'right':false, 'text-xs-left'? header.align='left':false ]"
          @click="changeSort(header.value)"
        >
          <v-icon small>fa-sort-up</v-icon>
          {{ header.text }}
        </th>
      </tr>
                  </template>-->
                  <template slot="items" slot-scope="props">
                    <tr :key="props.index">
                      <td
                        :class="[{'text-xs-left': !isCurrency(data.Value)}, {'text-xs-right': (isCurrency(data.Value)) || (colRightAlignKeyWordsIndex.includes(index))}, {'major': data.Style=='major'},{'subtotal':data.Style=='subtotal'}]"
                        class="mx-0 px-2"
                        :key="data.index"
                        v-for="(data, index) in props.item"
                      >
                        <div
                          v-if="(colBANIndex !== index) || (isNaN(data.Value)) || (data.Style !== 'details')"
                        >
                          <text-highlight :queries="searchHighlight">{{data.Value}}</text-highlight>
                        </div>
                        <router-link
                          v-if="(colBANIndex == index) &&(!isNaN(data.Value) && (data.Style == 'details'))"
                          class="mr-3"
                          style="text-decoration: none"
                          :to="openAccountSummaryPage(data.Value)"
                        >
                          <text-highlight :queries="search">{{data.Value}}</text-highlight>
                        </router-link>
                      </td>
                    </tr>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="red lighten-3"
                    icon="fa-exclamation-triangle"
                  >
                    Your
                    search for "{{ search }}" found no results.
                  </v-alert>
                  <template slot="no-data">
                    <v-layout row justify-start align-center>
                      <v-flex xs2 style="font-size: 14px;">
                        <span v-show="hasFilter">No records found for the applied filters</span>
                      </v-flex>
                      <v-flex xs8>
                        <v-btn color="primary" @click="initialize">Reset</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                  <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
                </v-data-table>
                <!-- END USERS TABLE -->

                <v-btn
                  color="primary"
                  @click="resetReportHistoryList"
                  v-show="showResetBtn && !loading"
                  style="margin-top: -40px;"
                >Reset</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-page>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import * as helper from "../../helpers/global.js";
import moment from "moment";
import TextHighlight from "vue-text-highlight";
import Spinner from "../../components/Spinner.vue";
import DataTablePagination from "../../components/DataTablePagination.vue";
import "@/assets/css/main.css"

export default {
  name: "ReportsView",

  components: {
    VPage,
    "text-highlight": TextHighlight,
    Spinner,
    DataTablePagination
  },

  data: () => ({
    dialog: false,
    search: "",
    loading: true,
    searchHighlight:"",

    showResetBtn: false,
    filters: {},
    filtersChanged: false,

    reportView: [],
    ddlCategory: [],
    ddlSubmitBy: [],
    totalRecords:0,

    reportInstanceId: null,
    reportId: null,

    reportInfo: {},
    colRightAlignKeyWordsIndex: [],
    colHeadersRightAlignIndex: [],
    rightAlignKeyWords: ["Amount", "Percentage"],

   

    // Selected by default
    pagination: {
      rowsPerPage: 30,
      descending: false,
      page: 1
    },
    headers: []
  }),

  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    }
  },

  computed: {
    hasFilter() {
      let result = false;

      Object.keys(this.filters).forEach(filter => {
        if (this.filters[`${filter}`]) {
          result = true;
        }
      });

      return result;
    },
     rowsPerPageItems(){ 
       var rowsPerPageItems =[
      30,
      45,
      60,
      100
    ]
    if (this.totalRecords < 1000){
      rowsPerPageItems.push(
      {
        text: "$vuetify.dataIterator.rowsPerPageAll",
        value: -1
      })
    }
    return rowsPerPageItems
    },
    breadcrumb() {
      var breadcrumb = [
        {
          text: "Reports",
          disabled: false,
          href: "#/reports"
        },
        {
          text: this.reportId,
          disabled: false,
          href: "#/report-history/" + this.reportId
        },
        {
          text: this.reportInstanceId,
          disabled: true,
          href: "#/report-view/" + this.reportInstanceId
        }
      ];
      return breadcrumb;
    },
    headersCount() {
      var headersCount = this.headers.length;
      return headersCount;
    },
    filteredItems() {
      return this.customSort(
        this.reportView.filter(i => {
          let result;
          Object.keys(i).forEach(z => {
            if (i[z].Value.toLowerCase().includes(this.search.toLowerCase())) {
              result = true;
            }
          });
          return result;
        })
      );
    },
    colBANIndex() {
      for (var i = 0; i < this.headers.length; i++) {
        var columnText = this.headers[i].text;
        if (columnText == "BAN") {
          var colBANIndex;
          return (colBANIndex = this.headers[i].value);
          break;
        }
      }
    }
  },

  created() {
    this.initialize();
    this.$root.$on("initialize", this.initialize);
  },

  destroyed() {
    this.$root.$off("initialize", this.initialize);
  },

  methods: {
    async initialize() {
      this.reportId = this.$route.params.ReportId;
      this.reportInstanceId = this.$route.params.ReportInstanceId;

      if (this.reportInstanceId !== "all") {
        this.filters = {
          reportInstanceId: this.reportInstanceId
        };

        this.filtersChanged = true;
        this.showResetBtn = false;
      } else {
        this.filters = {};
        this.filtersChanged = true;
        this.showResetBtn = false;
      }
      //inits headers
      var getHeadersInfo = await this.getHeadersInfo();
      this.getColRightAlignKeyWordsIndex();

      var paginationUpdated = await this.paginationUpdated();
      this.getHeadersRightAlign();

if (this.$route.query.search != null){
        this.search = this.$route.query.search;
    }
      this.loading = false;
    },

    // Get list of dropdown options
    getDropdownOptions(url, obj) {
      axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },

    async getHeadersInfo() {
      var ReportInstanceId = this.reportInstanceId;

      await axios
        .get("/api/Report/GetReportViewInfoList/" + ReportInstanceId)
        .then(res => {
          this.headers = res.data.headers;
          this.headers.forEach(element => {
            Object.assign(element, {
              class: "font-weight-bold subheading mx-0 px-2",
              align: "left"
            });
          });

          this.reportInfo = res.data.reportInfo;
        });
      return true;
    },

    async resetReportHistoryList() {
      this.loading = true;
      var reportInstanceId = this.reportInstanceId;
      var reportId = this.reportId;

      this.$router.push("/report-view/" + reportId + "/" + reportInstanceId);

      this.filters = {
        ReportInstanceId: this.reportInstanceId
      };
      this.filtersChanged = true;
      this.search = "";
      // this.breadcrumb[1].text = reportInstanceId

      await this.paginationUpdated();

      this.showResetBtn = false;
      this.loading = false;
    },

    async filterReports() {
      this.filtersChanged = true;
      this.showResetBtn = true;
      this.searchHighlight = this.search;
      this.updateSearchQuery()
      await this.paginationUpdated();
    },

    async paginationUpdated() {
      var headersCount = this.headersCount;
      this.loading = true;
      var reportInstanceId = this.reportInstanceId;
      await axios
        .post(
          "/api/Report/GetPagedReportViewList/" +
            reportInstanceId +
            "/" +
            headersCount,
          {
            postData: {
              pagination: this.pagination,
              filtersChanged: this.filtersChanged,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.reportView = response.data.reportView;
          this.totalRecords = response.data.totalRecords;
          //   console.log(response.data)
          // this.reportHistory = response.data.reportHistory
          // this.pagination.totalRecords = response.data.pagination.totalRecords
        });
      this.loading = false;
      this.filtersChanged = false;
    },
    openViewReport(item) {
      // this.$router.push("/account-summary/" + item.BAN);
    },
    isCurrency(data) {
      var item = data;
      item = item.toString();
      var isCurrency = item.startsWith("$");
      var isNegativeCurrency = item.startsWith("-$");
      // var isCurrencyType
      // var isNumberWithCommas
      // if (typeof item == 'undefined' || item == null || item == ""){}
      // else{
      //    isCurrencyType = /^\$?\d+(\.\d{2})?$/.test(item)

      //  isNumberWithCommas = /^\d{1,3}(,\d{3})*(\.\d+)?$/.test(item)
      // }
      if (isCurrency == true || isNegativeCurrency == true) {
        return true;
      } else {
        return false;
      }
    },
    exportToExcel() {
      var reportInstanceId = this.reportInstanceId;
      var reportTitle = this.reportInfo.ReportTitle;
      this.$refs.spinner.spinOn();
      axios({
        url: "/api/Report/ReportToExcel/" + reportInstanceId,
        method: "POST",
        responseType: "blob"
      })
        .then(response => {
          var currentDate = moment().format("YYYYMMDD.HHmm");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            reportTitle + "." + currentDate + ".xlsx"
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.$refs.spinner.spinOff();
        })
        .catch(err => {
          this.$refs.spinner.spinOff();
        });
    },
    exportToCSV() {
      var reportInstanceId = this.reportInstanceId;
      var reportTitle = this.reportInfo.ReportTitle;
      this.$refs.spinner.spinOn();
      axios({
        url: "/api/Report/ReportToCSV/" + reportInstanceId,
        method: "POST",
        responseType: "blob"
      })
        .then(response => {
          var currentDate = moment().format("YYYYMMDD.HHmm");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            reportTitle + "." + currentDate + ".csv"
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.$refs.spinner.spinOff();
        })
        .catch(err => {
          this.$refs.spinner.spinOff();
        });
    },
    customSort(items) {
      // The following is informations as far as I researched.
      // items: 'food' items
      // index: Enabled sort headers value. (black arrow status).
      // isDescending: Whether enabled sort headers is desc
      var sortBy = this.pagination.sortBy;
      var isDescending = this.pagination.descending;
      if (sortBy == null) {
        return items;
      } else {
        items.sort((a, b) => {
          if (isDescending) {
            if (!isNaN(b[`${sortBy}`].Value) && !isNaN(b[`${sortBy}`].Value)) {
              return b[`${sortBy}`].Value - a[`${sortBy}`].Value;
            } else {
              if (b[`${sortBy}`].Value > a[`${sortBy}`].Value) {
                return 1;
              }
              if (a[`${sortBy}`].Value > b[`${sortBy}`].Value) {
                return -1;
              }
              return 0;
            }
          } else {
            if (!isNaN(a[`${sortBy}`].Value) && !isNaN(b[`${sortBy}`].Value)) {
              return a[`${sortBy}`].Value - b[`${sortBy}`].Value;
            } else {
              if (b[`${sortBy}`].Value > a[`${sortBy}`].Value) {
                return -1;
              }
              if (a[`${sortBy}`].Value > b[`${sortBy}`].Value) {
                return 1;
              }
              return 0;
            }
          }
        });

        return items;
      }
    },
    openAccountSummaryPage(item) {
      return "/account-summary/" + item;
    },
    getColRightAlignKeyWordsIndex() {
      for (var i = 0; i < this.headers.length; i++) {
        var columnText = this.headers[i].text;
        if (this.rightAlignKeyWords.includes(columnText)) {
          this.colRightAlignKeyWordsIndex.push(this.headers[i].value);
        }
      }
    },
    async getHeadersRightAlign() {
      for (var i = 0; i < this.headers.length; i++) {
        var columnText = this.headers[i].text;
        if (this.rightAlignKeyWords.includes(columnText)) {
          this.colHeadersRightAlignIndex.push(this.headers[i].value);
        }
      }
      if (this.filteredItems.length > 0) {
        var reportView = this.reportView[0];
        await Object.keys(this.reportView[0]).forEach(z => {
          if (this.isCurrency(this.reportView[0][z].Value.toLowerCase())) {
            this.colHeadersRightAlignIndex.push(z);
          }
        });
      }
      for (var ii = 0; ii < this.headers.length; ii++) {
        if (this.colHeadersRightAlignIndex.includes(this.headers[ii].value)) {
          this.$set(this.headers[ii], "align", "right");
          this.headers.splice();
        }
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    updateSearchQuery(){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query
      var oldQuery = Object.assign({}, query)
      oldQuery.search=this.search
      this.$router.push({path:path, query:oldQuery})
    }
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}
/deep/table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
/deep/.theme--dark.v-table thead th {
  background-color: #424242;
}

/deep/.theme--light.v-table thead th {
  background-color: #fff;
}
/* Theme */
/deep/.fixed-header {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/deep/.fixed-header table {
}

/deep/.fixed-header th {
  position: sticky;
  top: 0;
  z-index: 5;
}

/deep/.fixed-header th:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}

/deep/.fixed-header tr.v-datatable__progress th {
  height: 1px;
}

/deep/.v-table__overflow {
  flex-grow: 1;
  flex-shrink: 1;
  overflow-x: auto;
  overflow-y: auto;
}

/deep/.fixed-header .v-datatable.v-table {
  flex-grow: 0;
  flex-shrink: 1;
}

/deep/.fixed-header .v-datatable.v-table .v-datatable__actions {
  flex-wrap: nowrap;
}

/deep/.fixed-header
  .v-datatable.v-table
  .v-datatable__actions
  .v-datatable__actions__pagination {
  white-space: nowrap;
}

.major {
  font-weight: bold;
  background-color: #e0e0e0;
}
.subtotal {
  font-weight: bold;
  color: #2196f3;
  background-color: #e3f2fd;
}
</style>
